export default {
	persons: {
		access: 'Access',
		contactInfo: 'Contact Information',
		noFurtherEmails: 'No further email addresses on file.',
		personalDoc: 'Personal Documents',
		accounts: 'Accounts',
		roles: {
			label: 'Visible to Role / Person Role',
		},
	},
}
